import "./styles.scss"
import { PPDWidgetItemValueProgress } from '../PPDWidgetItemValueProgress';
import { PPDWidgetBaseProperties } from '../PPDWidgetBaseProperties';
import { IUserDashboardLabels, IUserDashboardWidgetItemModel, UserDashboardWidgetModel } from 'shared/models';
import { useDashboardDict } from './../../../../context/useDashboardDict';
import { PPDModal } from '../../../PPDModal';
import { useMedia, useStore } from 'shared/hooks';
import { PPDWidgetGroupSelect } from './../../components/PPDWidgetGroupSelect';
import { EntityId } from 'shared/models/UserDashboardModel.ts';
import { PPWDWidgetNotice } from './../../components/PPDWidgetNotice';
import { observer } from 'mobx-react';

type PPDWidgetBaseStoreModalProps = {
    item: IUserDashboardWidgetItemModel
    onClose: () => void
    labels?: IUserDashboardLabels
    groups: UserDashboardWidgetModel['groups'];
    groupId: EntityId | null;
    onChangeGroup: (groupId: string | number) => void;
    isMonoStore?: boolean
}

export const PPDWidgetBaseStoreModal = observer(({ item, onClose, labels, groupId, groups, onChangeGroup, isMonoStore = false }: PPDWidgetBaseStoreModalProps) => {
    const { stores } = useDashboardDict();

    const store = useStore(() => ({
        isOpenNotice: false
    }))


    const storeName =
        item.store_id !== null
            ? stores?.find((s) => s.id === item.store_id)?.name ?? "-"
            : "-";

    const progress = Number(item.value?.amount ?? 0);

    const isMobileOrTablet = useMedia();

    const handleToggle = () => {
        if (!isMonoStore) return;
        store.set("isOpenNotice", true);
    };

    const handleCloseNotice = () => {
        store.set("isOpenNotice", false)
    }

    if (!item) {
        return null;
    }

    return (
        <>
            <PPDModal isOpened={!!item} onClose={onClose} className="ppd-widget-base-store-modal">
                <div className="ppd-widget-base-store-modal__header">{storeName}</div>
                {(groups.length > 0 || isMonoStore) && (
                    <div className="ppd-widget-base-store-modal__groups">
                        <PPDWidgetGroupSelect
                            items={groups}
                            value={groupId}
                            onChange={onChangeGroup}
                            activeToggle={!isMonoStore}
                            onClickToggle={handleToggle}
                        />
                    </div>
                )}
                <div className="ppd-widget-base-store-modal__content">
                    <div className="ppd-widget-base-store-modal__wrapper">
                        <PPDWidgetItemValueProgress
                            size={isMobileOrTablet ? 140 : 182}
                            strokeWidth={isMobileOrTablet ? 19 : 24}
                            progress={progress}
                        />
                    </div>

                    <PPDWidgetBaseProperties item={item} labels={labels}/>
                </div>
            </PPDModal>
            <PPWDWidgetNotice
                text="Невозможно изменить группу"
                isOpen={store.isOpenNotice}
                onClose={handleCloseNotice}
                autoHideDuration={5000}
            />
        </>
    );
});

